// Type definitions for API requests and responses

// Enums matching the API documentation
export enum LoanPurpose {
  Renovation = "renovation",
  FurnitureOrElectronics = "furniture_electronics",
  CarOrBoatOrMotorcycle = "vehicle",
  LivingCosts = "living_costs",
  Healthcare = "healthcare",
  Study = "study",
  HobbiesOrPet = "hobbies_pet",
  Holiday = "holiday",
  Wedding = "wedding",
  RepayExistingLoans = "repay_loans",
  Taxes = "taxes",
  Investments = "investments",
  LandOrProperty = "property",
  Company = "company",
  Other = "other"
}

export enum Education {
  Elementary = "elementary",
  TradeSchool = "trade_school",
  HighSchool = "high_school",
  CollegeLevel = "college_level",
  AssociateDegree = "associate_degree",
  VocationalDegree = "vocational_degree",
  Undergraduate = "undergraduate",
  Graduate = "graduate",
  Doctorate = "doctorate",
  ProfessionalDegree = "professional_degree",
  Other = "other"
}

export enum MaritalStatus {
  Married = "married",
  LiveTogether = "live_together",
  Divorced = "divorced",
  Single = "single",
  Widow = "widow",
}

export enum MainOccupation {
  Unemployed = "unemployed",
  Student = "student",
  Temporary = "temporary",
  PartTime = "part-time",
  Permanent = "permanent",
  Entrepreneur = "entrepreneur",
  Retired = "retired",
  Farmer = "farmer",
}

export enum NatureOfWork {
  SeniorManager = "senior_manager",
  UpperWhiteCollarWorker = "upper_white-collar_worker",
  LowerWhiteCollarWorker = "lower_white-collar_worker",
  Employee = "employee",
  LeaderOrDirector = "leader/director",
  Specialist = "specialist",
  Consultant = "consultant",
  BlueCollarWorker = "blue-collar_worker",
  MiddleManagement = "middle_management",
  Freelancer = "freelancer",
  ProjectManager = "project_manager",
  ResearcherOrAcademic = "researcher/academic",
  SalesRepresentative = "sales_representative",
  TechnicalSupport = "technical_support",
  CustomerService = "customer_service",
  Other = "other",
}

export interface CheckCustomerRequest {
  email: string;
  phoneNumber: string;
  affiliateId: string;
  offerId: string;
}

export interface CheckCustomerResponse {
  status: 'ACCEPTED' | 'REJECTED';
  reason?: string;
}

export interface CreateApplicationRequest {
  affiliateId: string;
  offerId: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  loanAmount: number;
  loanPeriodInMonths: number;
  loanPurpose?: LoanPurpose;
  education?: Education;
  maritalStatus?: MaritalStatus;
  underageChildrenCount?: number;
  mainOccupation?: MainOccupation;
  startOfEmployment?: string; // ISO8601 format: YYYY-MM-DD
  endOfEmployment?: string; // ISO8601 format: YYYY-MM-DD
  natureOfWork?: NatureOfWork;
  companyName?: string;
  monthlyGrossIncome?: number;
  monthlyNetIncome?: number;
}

export interface CreateApplicationResponse {
  token: string;
}
